import { createStyles } from 'antd-style';

import { ThemeBorderRadius, ThemeColors, ThemeSpaces } from '../../theme';

export const useMapCardStyles = createStyles(({ token }) => ({
  mapCard: {
    width: '100%',
    height: '100%',
    backgroundColor: ThemeColors.COLOR_WHITE,
    padding: ThemeSpaces.SPACE_SM,
    borderRadius: ThemeBorderRadius.BORDER_RADIUS_MD,
    boxShadow: `1px 1px 6px ${ThemeColors.COLOR_GREY8}`,

    '&.expanded': {
      [`@media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenMDMax}px)`]:
        {
          height: 320,
        },
      [`@media (max-width: ${token.screenSMMax}px)`]: {
        height: 220,
      },
    },
  },
}));
